import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { PublishedEventTypes } from '../../../constants/publishedEvent';
import { publisherPortalActions } from '../../../state/modules/publisher-portal';
import EventDetails from '../shared/publish-event/event-details';

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  addPublishedEvent: bindActionCreators(publisherPortalActions.publisherPortal.publishedEvent.savePublishedEvent, dispatch),
  updatePublishedEvent: bindActionCreators(publisherPortalActions.publisherPortal.publishedEvent.updatePublishedEvent, dispatch),
  getPublishedEventToUpdate: bindActionCreators(publisherPortalActions.publisherPortal.publishedEvent.getPublishedEventById, dispatch),
  deleteEvent: bindActionCreators(publisherPortalActions.publisherPortal.publishedEvent.deleteEvent, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(
    () => ({
      eventType: PublishedEventTypes.Course
    })
  )
)(EventDetails);


// WEBPACK FOOTER //
// ./src/containers/pages/publisher-portal/course-details.js